import { SocialChannelsEffects } from './social-channels.effect';

export const effects = [SocialChannelsEffects];
export * from './social-channels.effect';
